export const ENDPOINT_PRODUCT_HIGHLIGHT = '/backoffice/product/highlight';
export const ENDPOINT_PRODUCT_HIGHLIGHT_CG3 = '/backoffice/product/highlights';
export const BACKOFFICE_HIGHLIGHT_QUERY_KEY = 'BackofficeHighlights';
export const HIGHLIGHT_PAGE_SIZE = 25;

export const HIGHLIGHT_BREADCRUMB_LINKS = [
  { title: 'Beranda', link: '/' },
  { title: 'Highlight Management', link: '/highlight' },
];
